import { Paper, TableBody, TableCell, TableRow, Tooltip } from '@material-ui/core'
import React from 'react'
import NumericLabel from 'react-pretty-numbers';
import { EmptyCollection, TableListComp } from '../../../../shared_elements'
import moment from 'moment'
import { displayDateFormat } from '../../../../constants'
import { showCurrencyFormat } from '../../../../utils'
import { Info } from '@material-ui/icons';
import { jetStreamInstance } from '../../../../lease_management/Leases';
const rentalHd =(item)=>{
  return(
    item?.rental_accounts && Object.keys(item?.rental_accounts).length > 0 ?
    [
      { label: "Transaction Type" },
      { label: "Invoice Number" },
      { label: "Invoice Date" },
      { label: "Invoice Amount" },
      { label: "Cashflow Entry" },
      { label: "Total" }, 
      ...Object.keys(item?.rental_accounts)?.map(account => ({ label: account }))
    ]:
    []
  )
}
const RentalList = ({ item , params}) => {
  return (
    <TableRow className='cshflw-crd-bdy-row'>
      <TableCell>
        <div style={{ fontFamily: 'Conv_IBMPlexSans-medium' }}>{item?.transaction_type_name || '---'}</div>
        {item?.is_partial? <div>(Partial Payment)</div>:null}
        {item?.rental_invoice_type && jetStreamInstance? <div style={{fontWeight:'bold',textTransform:'uppercase',fontFamily:'Conv_IBMPlexSans-Medium'}}> ({item?.rental_invoice_type?.label})</div>:null}
      </TableCell>
      <TableCell>
        {item?.invoice_id?
          <p onClick={()=>{window.open(`invoice/view/${item?.invoice_id}`,'_blank')}}>{item?.invoice_number || '--'}</p>:
          '--'}
        </TableCell>
      <TableCell>{item?.invoice_date ? moment(item?.invoice_date).format(displayDateFormat) : '--'}</TableCell>
      <TableCell style={{color:item?.is_negative? 'red' : 'black'}}>
        <NumericLabel params={showCurrencyFormat()}>
          {item.invoice_amount || 0}
        </NumericLabel> &nbsp;
        {item?.invoice_excess_amount ?
          <Tooltip title={`Excess Amount: US$${item?.invoice_excess_amount}`} arrow>
            <Info style={{ fontSize: '15px' }} />
          </Tooltip> : null}
      </TableCell>
      <TableCell>{item?.cashflow_entry ? moment(item?.cashflow_entry).format(displayDateFormat) : '--'}</TableCell>
      <TableCell>
        <NumericLabel params={showCurrencyFormat()}>
          {item.total ||0}
        </NumericLabel>
      </TableCell>
      {item?.rental_accounts && Object.keys(item?.rental_accounts).length > 0 ?
        Object.keys(item?.rental_accounts).map((account, index) => (
          <TableCell key={index}>
            {item?.rental_accounts[account]?.amount && item?.rental_accounts[account]?.amount !== '--' ?
              <>
                <NumericLabel params={showCurrencyFormat()}>
                  {item?.rental_accounts[account]?.amount || 0}
                </NumericLabel> &nbsp;
                {item?.rental_accounts[account]?.excess_amount ?
                  <Tooltip title={`Excess Amount: US$${item?.rental_accounts[account]?.excess_amount}`} arrow>
                    <Info style={{ fontSize: '15px' }} />
                  </Tooltip> : null}
              </>
              : '--'}
          </TableCell>
        )) : <TableCell>--</TableCell>
      }
    </TableRow>
  )
}
export default function RentalCard({ data, params }) {
    let rentalHeaders = rentalHd(data?.items[0]);
  return (
    <div className="cshflw-crd">
      <div className="cshflw-crd-hdr">
        <h5>Rental</h5>
        <div>Total Balance: &nbsp;
       <b> <NumericLabel params={showCurrencyFormat()}>
          {data.total ||0}
        </NumericLabel>
        </b>
        </div>
      </div>
      <div className="cshflw-crd-bdy">
        <TableListComp
          xScroll={true}
          maxheight={'max-content'}
          heads={rentalHeaders}
          data={data?.items.map((item, index) =>
            <RentalList
              params={params}
              key={index}
              item={item}
            />
          )}
        />
      </div>
    </div>
  )
}
